import * as yup from "yup";


const EmploymentInformationSchema = yup.object().shape({
    livingStatus: yup.string().min(2).required('Field is Required'),
    addressDuration: yup.string().min(2).required('Field is Required'),
    changesToIncomeOverYear: yup.string().min(2).required('Field is Required'),
    documentationConsent: yup.string().min(2).required('Field is Required'),
    additionalIncome: yup.string().min(2).required('Field is Required'),
    employmentStatus: yup.string().min(2).required('Field is Required'),
    employmentDuration: yup.string()
});


export default EmploymentInformationSchema;